// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { TAG_NAMES, FONT_WEIGHT, FONT_COLOR, TEXT_ALIGN, HEADING_COLORS, TEXT_TRANSFORM } from '../Base/Base';
import { StyledCopyParagraph } from './CopyParagraph.styles';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

function CopyParagraph({
  tagName,
  weight,
  color,
  children,
  align,
  noMargins,
  className,
  textTransform,
  title,
  marginTop
}) {
  return (
    <StyledCopyParagraph
      tagName={tagName}
      color={HEADING_COLORS[color]}
      align={align}
      textTransform={textTransform}
      weight={weight}
      noMargins={noMargins}
      className={className}
      title={title}
      marginTop={marginTop}
    >
      {children}
    </StyledCopyParagraph>
  );
}

CopyParagraph.propTypes = {
  /** Font Color: primary, secondary, tertiary, quaternary */
  color: PropTypes.oneOf(FONT_COLOR),
  /** Font Weight: normal, bold */
  weight: PropTypes.oneOf(FONT_WEIGHT),
  /** Element tag name: h1, h2, h3, h4, h5, h6, div, span, label, p, strong, li */
  tagName: PropTypes.oneOf(TAG_NAMES),
  /** Copy alignment: inherit, left, center, right, justify */
  align: PropTypes.oneOf(TEXT_ALIGN),
  /** Text Transform: none, capitalize, uppercase, lowercase, initial, inherit */
  textTransform: PropTypes.oneOf(TEXT_TRANSFORM),
  /** Copy/elements you want inside */
  children: ReactChildrenPropType,
  /** Remove default margins */
  noMargins: PropTypes.bool,
  /** Allows component to be overwritten by StyledComponents */
  className: PropTypes.string,
  title: PropTypes.string,
  marginTop: PropTypes.number
};

CopyParagraph.defaultProps = {
  color: 'primary',
  weight: 'normal',
  tagName: 'p',
  align: 'inherit',
  textTransform: 'none',
  children: null,
  noMargins: false,
  className: '',
  title: '',
  marginTop: undefined
};

export default CopyParagraph;
